import { TRIOLIET_BORDER_RADIUS, TRIOLIET_BOX_SHADOW, TRIOLIET_COLORS, TRIOLIET_FONTS, TRIOLIET_SPACING, } from '../triolietThemeConf';
export const triolietNotificationsStyle = {
    Containers: {
        DefaultStyle: {
            width: 500,
            top: 'auto',
            bottom: 0,
            margin: '0 auto 0 -250px',
            left: '50%',
        },
    },
    NotificationItem: {
        DefaultStyle: {
            width: 500,
            minHeight: 60,
            height: 'auto',
            border: 0,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            paddingLeft: '5.5em',
            borderRadius: TRIOLIET_BORDER_RADIUS.default,
            boxShadow: TRIOLIET_BOX_SHADOW.default,
        },
        success: {
            backgroundColor: TRIOLIET_COLORS.success.main,
        },
        info: {
            backgroundColor: TRIOLIET_COLORS.brand.main,
        },
        error: {
            backgroundColor: TRIOLIET_COLORS.error.main,
        },
        warning: {
            backgroundColor: TRIOLIET_COLORS.warning.main,
        },
    },
    Dismiss: {
        DefaultStyle: {
            display: 'none',
        },
    },
    Title: {
        DefaultStyle: {
            color: TRIOLIET_COLORS.font.light,
            fontSize: TRIOLIET_FONTS.size.mediumBig,
            fontWeight: TRIOLIET_FONTS.weight.bold,
            height: TRIOLIET_FONTS.size.mediumBig,
            marginBottom: 0,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        },
    },
    MessageWrapper: {
        DefaultStyle: {
            minHeight: 20,
            fontSize: TRIOLIET_FONTS.size.medium,
            fontWeight: TRIOLIET_FONTS.weight.normal,
            lineHeight: 1.67,
            textAlign: 'left',
            color: TRIOLIET_COLORS.font.light,
            marginTop: TRIOLIET_SPACING.margin.smallest,
        },
    },
};
//# sourceMappingURL=triolietNotificationsStyle.js.map